import {Map, fromJS} from 'immutable'

import {
  CHAT_LIST_WIDTH,
  CHAT_LIST_RIGHT_MARGIN,
  CONVERSATION_PANE_WIDTH,
  VIEWPORT_MAX_WIDTH_PHONE
} from '../../config/constants'

import {
  SET_CONVERSATION_REFS,
  SET_CONVERSATION_STACK,
  SET_FOCUSED_CONVERSATION,
  SET_LAST_OPEN_TIME_FOR_CONVERSATION,
  SET_TOTAL_CONV_MESSAGE_COUNT,
  SET_READ_CONV_MESSAGE_COUNT,
  SET_VIEWPORT_DIMENSIONS
} from '../action_types'

const TOTAL_CHAT_LIST_WIDTH = CHAT_LIST_RIGHT_MARGIN + CHAT_LIST_WIDTH

const getVisibleSlot = (width) => {
  if (width <= VIEWPORT_MAX_WIDTH_PHONE) return 1

  return parseInt(((width - TOTAL_CHAT_LIST_WIDTH) / CONVERSATION_PANE_WIDTH), 10)
}

const reduceConversationCounts = (state = fromJS({}), action) => {
  switch (action.type) {
    case SET_TOTAL_CONV_MESSAGE_COUNT:
      state = state.setIn([action.conversationId, 'total'], action.count || 0)

      const read = state.getIn([action.conversationId, 'read'], action.count)

      if (read === 0) {
        state = state.setIn([action.conversationId, 'unread'], 0)
      }
      else {
        state = state.setIn([action.conversationId, 'unread'], action.count - read)
      }

      return state

    case SET_READ_CONV_MESSAGE_COUNT:
      state = state.setIn([action.conversationId, 'read'], action.count || 0)

      const total = state.getIn([action.conversationId, 'total'], action.count)

      if (action.count === 0) {
        state = state.setIn([action.conversationId, 'unread'], 0)
      }
      else {
        state = state.setIn([action.conversationId, 'unread'], action.count - total)
      }

      return state

    default:
      return state
  }
}

const reduceConversationStack = (state = fromJS({}), action) => {
  switch (action.type) {
    case SET_CONVERSATION_STACK:
      const visibleSlot = state.get('visibleSlot')
      const stack = action.stack ? fromJS(action.stack) : fromJS([])

      state = state.set('list', stack)
      state = state.set('visibles', state.get('list').take(visibleSlot))

      return state

    case SET_VIEWPORT_DIMENSIONS:
      const currentVisibleSlot = state.get('visibleSlot')
      const newVisibleSlot = getVisibleSlot(action.width)

      if (newVisibleSlot !== currentVisibleSlot) {
        state = state.set('visibleSlot', newVisibleSlot)
        state = state.set('visibles', state.get('list', fromJS([])).take(newVisibleSlot))

        return state
      }

    case SET_FOCUSED_CONVERSATION:
      if (action.isFocused) {
        const focused = state.get('focused')
        if (focused !== action.index) {
          return state.set('focused', action.index)
        }
      }
      else {
        return state.delete('focused')
      }

    default:
      return state
  }
}

export default (state = Map({}), action) => {
  switch (action.type) {
    case SET_CONVERSATION_REFS:
      return state.mergeDeep({_refs: action.refs})

    case SET_CONVERSATION_STACK:
    case SET_VIEWPORT_DIMENSIONS:
    case SET_FOCUSED_CONVERSATION:
      return state.set(
        '_stack',
        reduceConversationStack(state.get('_stack'), action)
      )

    case SET_TOTAL_CONV_MESSAGE_COUNT:
    case SET_READ_CONV_MESSAGE_COUNT:
      return state.set(
        '_counts',
        reduceConversationCounts(state.get('_counts'), action)
      )

    case SET_LAST_OPEN_TIME_FOR_CONVERSATION:
      return state.setIn(['_lastOpenTimes', action.conversationId], action.time)

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/conversations.js
 **/